import { Controller } from "@hotwired/stimulus"

const $ = window.jQuery

export default class extends Controller {
  connect() {
    this.initializeAutoKana()
    this.initializeJpostal()
    this.initializeTypeToggle()
    this.initializeToggleNextDiv()
    this.initializeSelect2()
    this.setupHiddenFieldDisabling()
  }

  initializeAutoKana() {
    $.fn.autoKana('#contact_last_name', '#contact_last_name_kana', {})
    $.fn.autoKana('#contact_first_name', '#contact_first_name_kana', {})
    $.fn.autoKana('#contact_company_name', '#contact_company_name_kana', {})
    $.fn.autoKana('#lawyer_last_name', '#lawyer_last_name_kana', {})
    $.fn.autoKana('#lawyer_first_name', '#lawyer_first_name_kana', {})
    $.fn.autoKana('#lawyer_company_name', '#lawyer_company_name_kana', {})
  }

  initializeJpostal() {
    window.jpostalPreservingInput("#contact_postal_code", {
      postcode: ["#contact_postal_code"],
      address: {
        "#contact_address": "%3%4%5%6%7"
      }
    })
    window.jpostalPreservingInput("#contact_company_postal_code", {
      postcode: ["#contact_company_postal_code"],
      address: {
        "#contact_company_address": "%3%4%5%6%7"
      }
    })
    window.jpostalPreservingInput("#lawyer_company_postal_code", {
      postcode: ["#lawyer_company_postal_code"],
      address: {
        "#lawyer_company_address": "%3%4%5%6%7"
      }
    })
  }

  initializeTypeToggle() {
    const $root = $(this.element)

    const setDefaultType = () => {
      if (!$root.find('#contact_contact_type_company').prop('checked') && !$root.find('#contact_contact_type_lawyer').prop('checked')) {
        $root.find('#contact_contact_type_person').prop('checked', true)
      }
    }

    const toggleContactTypeFields = () => {
      if ($root.find('#contact_contact_type_person').prop('checked')) {
        $root.find('#company_input').hide()
        $root.find('#lawyer_input').hide()
        $root.find('#person_org').show()
        $root.find('#person_input').show()
      } else if ($root.find('#contact_contact_type_company').prop('checked')) {
        $root.find('#company_input').show()
        $root.find('#lawyer_input').hide()
        $root.find('#person_org').hide()
        $root.find('#person_input').hide()
      } else {
        $root.find('#company_input').hide()
        $root.find('#lawyer_input').show()
        $root.find('#person_org').hide()
        $root.find('#person_input').hide()
      }
    }

    setDefaultType()
    toggleContactTypeFields()

    $root.find('input[name="contact[contact_type]"]:radio').on('change', () => {
      toggleContactTypeFields()
    })
  }

  initializeToggleNextDiv() {
    $(this.element).find(".toggle-next-div").on('click', function () {
      $("+div", this).toggle(200)
      $("span", this).toggleClass("fa-minus-square")
      $("span", this).toggleClass("fa-plus-square")
    })
  }

  initializeSelect2() {
    const $root = $(this.element)
    // Bootstrap 3 の enforceFocus が body 直下の select2 検索欄を奪うため、
    // モーダル内の select2 には必ず dropdownParent を渡す。
    // 親連絡先は select2 controller が初期化する(二重初期化すると allowClear が消える)。
    const $modal = $root.closest(".modal")

    const $userSelect = $root.find("select#contact_user_id")
    if ($userSelect.is(':visible')) {
      $userSelect.select2({ language: "ja", dropdownParent: $modal, width: "100%" })
    }
  }

  // 非表示セクションの入力は送信前に disabled にして重複フィールドの衝突を避ける。
  // 成功・失敗どちらもモーダルが差し替わるので通常は戻す必要がないが、送信が
  // 中断した場合(通信エラー、stream を返さない 5xx)にフォームが無効化されたまま
  // 残るので、turbo:submit-end で必ず戻す。
  setupHiddenFieldDisabling() {
    this.disableHiddenSections = this.disableHiddenSections.bind(this)
    this.enableAllSections = this.enableAllSections.bind(this)
    this.element.addEventListener('submit', this.disableHiddenSections, true)
    this.element.addEventListener('turbo:submit-end', this.enableAllSections)
  }

  disconnect() {
    this.element.removeEventListener('submit', this.disableHiddenSections, true)
    this.element.removeEventListener('turbo:submit-end', this.enableAllSections)
  }

  disableHiddenSections() {
    $(this.element).find('#company_input, #lawyer_input, #person_org, #person_input').each(function () {
      if ($(this).is(':hidden')) {
        $(this).find('input, select, textarea').prop('disabled', true)
      }
    })
  }

  enableAllSections() {
    $(this.element)
      .find('#company_input, #lawyer_input, #person_org, #person_input')
      .find('input, select, textarea')
      .prop('disabled', false)
  }
}
